'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, person_id, data) {
  return function (dispatch, getState) {
    dispatch(_defineProperty({
      feis_id: feis_id,
      person_id: person_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisRegistrationsForPersonUrl)(feis_id, person_id),
        method: 'POST',
        data: data
      },
      types: ['CREATE_REGISTRATION_START', 'CREATE_REGISTRATION', 'CREATE_REGISTRATION_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/registrations/createRegistration.js
// module id = 666
// module chunks = 0